// extracted by mini-css-extract-plugin
module.exports = {"swiper":"Carousel_swiper__yrmuW"};